import { Component, Input, OnInit } from '@angular/core';
import { UserInfoModel } from 'src/app/models/users/UserInfoModel';
import { formatDate } from 'src/app/shared/utils/Formatters';

@Component({
  selector: 'emergency-details',
  templateUrl: './emergency-details.component.html',
  styleUrls: ['./emergency-details.component.scss']
})
export class EmergencyDetailsComponent implements OnInit {

  @Input() user: UserInfoModel;
  formatDateForTable = formatDate;

  constructor() { }

  ngOnInit() {
  }

}
